import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  readonly loading$ = this.loadingSubject.asObservable();
  readonly isLoading = toSignal(this.loading$, { initialValue: false });

  play(): void {
    this.loadingSubject.next(true);
  }

  stop(): void {
    this.loadingSubject.next(false);
  }
}
